const baseURL = 'https://antarafastfood.com/';

export default baseURL;
